module.exports = __webpack_public_path__ + "8434b9fa8c0f7c29031e632e1f739dbf.svg";